import { useTranslation } from 'react-i18next'

function NotFound() {
  const { t } = useTranslation('common')
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <h1 className="text-6xl font-bold">404</h1>
      <p className="text-2xl mt-2">{t('pageNotFound')}</p>
    </div>
  )
}

export default NotFound
